/* eslint-disable react/prop-types */
import React, { Component } from "react";
import moment from "moment";

import DATE_FORMATS from "../utilities/constants";
import { convert } from "../utilities/time";

class TextFieldTimeField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: moment(new Date()).format("YYYY-MM-DD")
    };

    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    this.interval = this.updateTime();
  }

  componentWillUnmount() {
    window.clearInterval(this.interval);
  }

  onBlur() {
    const { date } = this.state;
    // # we first convert the human time into HH:mm, and then display the reformatted human time
    // # combine the selected date and the current time together to get 'now'
    const datetime = moment(`${date} ${moment().format(DATE_FORMATS.Time)}`);
    let converted = convert(this.textInput.value, datetime, "not valid");

    if (converted === "not valid") {
      converted = moment().format(DATE_FORMATS.Time);
    }

    this.setInputFieldTime(converted);
  }

  setInputFieldTime(time) {
    const { onChange } = this.props;
    this.textInput.value = moment(time, DATE_FORMATS.Time).format(
      DATE_FORMATS.TimeHumanReadable
    );

    const name = this.textInput.getAttribute("name");
    onChange({ [name]: this.textInput.value });
  }

  updateTime() {
    const interval = () => {
      const converted = moment().format(DATE_FORMATS.Time);
      this.setInputFieldTime(converted);
    };

    // update time every 30 seconds
    window.setInterval(interval, 30 * 1000);

    interval();
  }

  render() {
    const { name } = this.props;
    return (
      <input
        ref={e => {
          this.textInput = e;
        }}
        name={name}
        className="ember-view ember-text-field time-input"
        type="text"
        onBlur={this.onBlur}
      />
    );
  }
}

export default TextFieldTimeField;
